<template>
  <!-- A brand label stands in for the brand at the start of the title, so the
       row still reads as the insurer's name. -->
  <span
    v-if="visibleLogo?.kind === 'wordmark'"
    data-qa="insurance-title"
    ><span
      data-qa="insurance-logo"
      class="insurance-option-label__brand"
      ><span
        v-for="part in visibleLogo.wordmark"
        :key="part.text"
        :style="selected ? undefined : { color: part.color }"
        >{{ part.text }}</span
      ></span
    >{{ visibleLogo.titleRest }}</span
  >
  <template v-else>
    <!-- An image shown alone stands for the insurer's name; next to the title
         it only repeats the brand. -->
    <span
      v-if="visibleLogo"
      data-qa="insurance-logo"
      :role="visibleLogo.showsTitle ? undefined : 'img'"
      :aria-label="visibleLogo.showsTitle ? undefined : title"
      :aria-hidden="visibleLogo.showsTitle ? 'true' : undefined"
    >
      <img
        :src="visibleLogo.src"
        alt=""
        class="insurance-option-label__image"
        @error="imageFailed = true"
      />
    </span>
    <span
      v-if="!visibleLogo || visibleLogo.showsTitle"
      data-qa="insurance-title"
    >
      {{ title }}
    </span>
  </template>
</template>

<script setup>
// An insurer's name in the insurance selection list: the title with its brand
// label in color, or an image logo from the backend with or without the title.
import { computed, ref } from 'vue'

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  // An InsuranceLogo from @eu/app/helpers/insuranceLogos.
  logo: {
    type: Object,
    default: null,
  },
  // A selected row turns dark blue with white text, where brand colors would
  // disappear, so the label takes the row's text color.
  selected: {
    type: Boolean,
    default: false,
  },
})

const imageFailed = ref(false)

// A logo image that fails to load falls back to the insurer's name.
const visibleLogo = computed(() => (imageFailed.value ? null : props.logo))
</script>

<style lang="scss">
.insurance-option-label__brand {
  white-space: nowrap;
}

.insurance-option-label__image {
  display: block;
  height: 26px;
  max-width: 120px;
  object-fit: contain;
}
</style>
